<template>
    <div class="people-counter"
         @mouseover="hover = true"
         @mouseleave="hover = false">
        <input ref="counterInput"
               type="text"
               v-model="counterValue"
               @focus="unFocus()"
               @click="toggleList()"/>
        <div v-if="showList" ref="counterList" class="counter-list">
            <div v-for="(item, key) in items"
                 :key="key"
                 :class="['counter-list-item',{'focus': moveKey.position === key}]">
                <span>{{localizeList[item.name]}}</span>
                <base-button @click.native="remove(key)" background="var(--lighten-1-color)">
                    <svg width="12px" height="12px" fill="var(--lighten-5-color)">
                        <use xlink:href="../../../assets/images/sprite.svg#minus"></use>
                    </svg>
                </base-button>
                <span class="count">{{item.count}}</span>
                <base-button @click.native="add(key)" background="var(--primary-color)">
                    <svg width="12px" height="12px" fill="var(--white-color)">
                        <use xlink:href="../../../assets/images/sprite.svg#plus"></use>
                    </svg>
                </base-button>
            </div>

            <!--Добовляем список возрастов по кол-во выбраных детей-->
            <div v-for="(item, key) in dataValue.children"
                 :key="`${key}-child`"
                 :class="['counter-list-item',{'focus': moveKey.position === key + 2}]">
                <span :style="item.css">{{convertChildAges(item.name, key+1)}}</span>
                <base-button @click.native="removeAge(key)" background="var(--lighten-1-color)">
                    <svg width="12px" height="12px" fill="var(--lighten-5-color)">
                        <use xlink:href="../../../assets/images/sprite.svg#minus"></use>
                    </svg>
                </base-button>
                <input type="text" class="count" v-model="item.age"/>
                <base-button @click.native="addAge(key)" background="var(--primary-color)">
                    <svg width="12px" height="12px" fill="var(--white-color)">
                        <use xlink:href="../../../assets/images/sprite.svg#plus"></use>
                    </svg>
                </base-button>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "people-counter",
        data() {
            return {
                showList: false,
                hover: false,
                dataValue: {
                    adult: {},
                    children: []
                },
                moveKey: {
                    position: 0
                }
            }
        },
        props: {
            items: {
                type: Array,
                default: () => []
            },
            value: {
                type: Object,
                default: () => {}
            },
            show: {
                type: Boolean,
                default: false
            },
            focusFromParent: {
                type: Boolean,
                default: false
            }
        },
        created() {
            window.addEventListener('keydown', this.keyDown);
        },
        mounted() {
            this.showList        = this.show;
            this.dataValue.adult = Object.assign({}, this.items[0])
            this.list            = this.items.slice()

            window.addEventListener("click", () => {
                if (!this.hover) {
                    this.hideList();
                }
            })
        },
        computed: {
            childMaxAge() {
                const settings = this.$store.getters['getSettings'];
                return settings.ChildAgesSetting[settings.ChildAgesSetting.length-1] || 18;
            },
            counterValue() {
                const { adult, children } = this.dataValue;
                const params = [
                  {
                    value: `${this.localizeList[adult.name]} ${adult.count}`,
                    condition: adult.count
                  },
                  {
                    value: `, ${this.localizeList['childs']} ${children.length}`,
                    condition: children.length
                  },
                  {
                    value: ` (${[...new Set(children.map(({ age }) => age).filter(item => item))].sort((a, b) => a - b).join(', ')})`,
                    condition: children.map(({ age }) => age).filter(item => item).length
                  }
                ]

                return params.filter((el) => el.condition).map(el => el.value).join('') 
            },
        },
        methods: {
            toggleList() {
                this.showList = !this.showList
            },
            hideList() {
                this.showList = false
            },
            unFocus() {
                this.$refs.counterInput.blur()
            },
            convertChildAges(text, nth) {
                let localCode = this.$store.getters['getLocalizeCode'];
                let name = "";
                if (nth === 1 || localCode != "en") {
                    name = this.localizeList[text].replace("{}", nth)
                } else if (nth === 2) {
                    name = this.localizeList[text].replace("{}-st", nth + "nd")
                } else if (nth === 3) {
                    name = this.localizeList[text].replace("{}-st", nth + "rd")
                } else {
                    name = this.localizeList[text].replace("{}-st", nth + "th")
                }
                return name
            },
            add(key) {
                // let localCode = this.$store.getters['getLocalizeCode'];
                this.items[key].count++;
                if (key === 0) {
                    this.dataValue.adult.count++
                } else if (key === 1) {
                    // let nth = this.dataValue.children.length + 1;
                    // let name = "";
                    // if (nth === 1 || localCode != "en") {
                    //     name = this.localizeList.ageOfChild.replace("{}", nth)
                    // } else if (nth === 2) {
                    //     name = this.localizeList.ageOfChild.replace("{}-st", nth + "nd")
                    // } else if (nth === 3) {
                    //     name = this.localizeList.ageOfChild.replace("{}-st", nth + "rd")
                    // } else {
                    //     name = this.localizeList.ageOfChild.replace("{}-st", nth + "th")
                    // }
                    this.dataValue.children.push({
                        name: "ageOfChild",
                        css: {
                            marginLeft: "20px"
                        },
                        age: null
                    })
                }
            },
            remove(key) {
                if (key === 0 && this.items[key].count > 1) {
                    this.items[key].count--
                    this.dataValue.adult.count--
                } else if (key === 1 && this.items[key].count > 0) {
                    this.items[key].count--;
                    this.dataValue.children.pop()
                }
            },
            addAge(key) {
                if (this.dataValue.children[key].age < this.childMaxAge)
                    this.dataValue.children[key].age++
            },
            removeAge(key) {
                if (this.dataValue.children[key].age > 0)
                    this.dataValue.children[key].age--
            },
            keyDown(e) {
                if (this.showList && e.keyCode === 9) {
                    this.hideList();
                    this.$emit("tab")
                }

                if (!this.showList) {
                    return
                }
                if (e.keyCode === 40) {
                    e.preventDefault();
                    if (this.moveKey.position < this.dataValue.children.length + 1) {
                        this.moveKey.position++;
                        this.$refs.counterList.scrollBy(0, 65);
                    }
                }
                if (e.keyCode === 38) {
                    e.preventDefault();
                    if (this.moveKey.position > 0) {
                        this.moveKey.position--;
                        this.$refs.counterList.scrollBy(0, -65)
                    }
                }
                if (e.keyCode === 39) {
                    if (this.moveKey.position < 2) {
                        this.add(this.moveKey.position)
                    } else {
                        this.addAge(this.moveKey.position - 2)
                    }
                }
                if (e.keyCode === 37) {
                    if (this.moveKey.position < 2) {
                        this.remove(this.moveKey.position)
                    } else {
                        this.removeAge(this.moveKey.position - 2)
                    }
                }

            },
        },
        beforeDestroy() {
            window.removeEventListener('keydown', this.keyDown);
        },
        watch: {
            focusFromParent(val) {
                if (val) {
                    setTimeout(() => this.showList = true, 0)
                }
            },
            value: {
                immediate: true,
                handler(val) {
                    this.dataValue.adult = Object.assign({}, val.adult)
                    this.dataValue.children = val.children.slice()
                }
            },
            dataValue: {
                immediate: true,
                handler(val) {
                    this.$emit("input", val)
                }
            },
            "dataValue.children": {
                deep: true,
                handler(val) {
                    val.forEach((x, i) => {
                        if (x.age > this.childMaxAge) {
                            this.dataValue.children[i].age = this.childMaxAge
                        } else if (x.age < 0){
                            this.dataValue.children[i].age = 0
                        } else if (typeof x.age == "string" && x.age.includes("00")) {
                            this.dataValue.children[i].age = 0
                        }
                        if(typeof x.age == "string" && x.age.match(/\D/)){
                            this.dataValue.children[i].age = 0
                        }
                        if(typeof x.age == "string" && x.age.length === 2 && x.age[0] == 0){
                            this.dataValue.children[i].age = +x.age
                        }
                    });
                    this.$emit("input", this.dataValue)
                }
            },
            showList(val) {
                if (val) {
                    this.$emit("focus")
                } else {
                    this.$emit("hide");
                    this.$emit("blur")
                }
            },
            show(val) {
                this.showList = val
            }
        }
    }
</script>

<style scoped>
    .people-counter {
        position: relative;
    }
    .people-counter input {
        width: 100%;
        border: none;
        outline: none;
        padding: 8px 40px 8px 12px;
        background-color: var(--lighten-6-color);
        border-radius: 3px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #333;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .people-counter input::placeholder {
        color: var(--lighten-5-color);
    }
    .people-counter .counter-list {
        position: absolute;
        top: 100%;
        right: 0;
        width: 100%;
        min-width: 300px;
        max-height: 260px;
        background-color: var(--white-color);
        box-shadow: 0px 1px 20px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        padding: 0;
        overflow: auto;
        z-index: 100;
    }
    .people-counter .counter-list .counter-list-item{
        display: grid;
        grid-template-columns: 1fr auto 20px auto;
        grid-gap: 8px;
        align-items: center;
        padding: 16px 16px;
    }
    .people-counter .counter-list .counter-list-item.focus {
        background-color: #fafafa;
    }
    .people-counter .counter-list .counter-list-item .count{
        text-align: center;
        width: 20px;
        border: none;
        outline: none;
        padding: 0;
        background: transparent;
    }
    .people-counter .counter-list .counter-list-item:not(:last-child){
        border-bottom: 1px dashed #E0E0E0;
    }
</style>
